export default __webpack_public_path__ + "static/media/category6.fc39f070.png";